import { LegalPage } from "./LegalPage";

const SECTIONS = [
  { h: "1. Éditeur du site", p: "Le service « Kallitag Lead Capture » est édité par Kallitag.\nForme juridique : [À COMPLÉTER]. Capital social : [À COMPLÉTER].\nSiège social : [À COMPLÉTER]. SIREN/SIRET : [À COMPLÉTER]. TVA intracommunautaire : [À COMPLÉTER].\nContact : contact@kallitag.fr." },
  { h: "2. Directeur de la publication", p: "[Nom du représentant légal — À COMPLÉTER]." },
  { h: "3. Hébergement", p: "L'application est hébergée sur une infrastructure cloud gérée. Les coordonnées précises de l'hébergeur et la région d'hébergement sont disponibles sur demande à contact@kallitag.fr." },
  { h: "4. Propriété intellectuelle", p: "L'ensemble des éléments du service (marque Kallitag, logos, interfaces, code, contenus) est protégé par le droit de la propriété intellectuelle. Toute reproduction ou réutilisation sans autorisation écrite est interdite." },
  { h: "5. Responsabilité", p: "Kallitag met tout en œuvre pour assurer l'exactitude des informations et la disponibilité du service, sans garantie d'absence d'interruption. L'utilisateur reste responsable des données qu'il saisit et de leur licéité." },
  { h: "6. Données personnelles", p: "Le traitement des données personnelles est décrit dans la Politique de confidentialité et, pour les données de prospects confiées par les clients, dans l'Accord de traitement des données (DPA)." },
];

export default function MentionsLegalesPage() {
  return (
    <LegalPage
      testid="mentions-legales-page"
      kicker="Kallitag Lead Capture"
      title="Mentions légales"
      updated="Dernière mise à jour : juin 2026."
      disclaimer="Modèle à compléter avec les informations légales de la société et à faire valider par un conseil juridique."
      sections={SECTIONS}
    />
  );
}
